// src/components/UserTransactionHistory.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import "./UserTransactionHistory.css";
import logo from "../../Assets/logo.jpg";

const UserTransactionHistory = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get(`/user/${userId}/wallet-history`);
        setTransactions(res.data.transactions || []);
        setUser(res.data.user || {});
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || "Failed to fetch transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [userId]);

  // Optional: Calculate running balance if backend doesn't send remainingBalance
  const transactionsWithBalance = useMemo(() => {
    let balance = 0;
    return transactions.map((tx) => {
      balance = tx.type === "credit" ? balance + tx.amount : balance - tx.amount;
      return { ...tx, balanceAfter: balance };
    });
  }, [transactions]);

  return (
    <div className="transaction-history-container">
      {/* Header with back arrow and title */}
      <div className="transaction-history-header">
        <button onClick={() => navigate(-1)} className="back-button">
          ←
        </button>
        <h2>User Wallet Transactions</h2>
      </div>

      {loading && <p className="loading">Loading...</p>}
      {error && <p className="error">{error}</p>}

      {!loading && !error && (
        <>
          <div className="user-info">
            <p>
              <strong>Name:</strong> {user.name}
            </p>
            <p>
              <strong>Email:</strong> {user.email}
            </p>
            <p>
              <strong>Mobile:</strong> {user.mobile}
            </p>
            <p>
              <strong>Wallet Balance:</strong>{" "}
              <span className="wallet-balance">
                <img src={logo} alt="coin" className="coin-icon" />
                {user.wallet}
              </span>
            </p>
          </div>

          {/* Table wrapper for horizontal scroll */}
          <div className="transaction-table-wrapper">
            <table className="transaction-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Description</th>
                  <th>Remaining Balance</th>
                </tr>
              </thead>
              <tbody>
                {transactionsWithBalance.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No transactions found
                    </td>
                  </tr>
                ) : (
                  transactionsWithBalance.map((tx) => (
                    <tr key={tx._id}>
                      <td>{new Date(tx.createdAt).toLocaleString()}</td>
                      <td
                        className={tx.type === "credit" ? "credit" : "debit"}
                      >
                        {tx.type.toUpperCase()}
                      </td>
                      <td>
                        <div className="amount-wrapper">
                          <img src={logo} alt="coin" className="coin-icon" />
                          {tx.amount}
                        </div>
                      </td>
                      <td>{tx.description}</td>
                      <td>
                        <div className="amount-wrapper">
                          <img src={logo} alt="coin" className="coin-icon" />
                          {tx.balanceAfter}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Card layout for small screens */}
          <div className="transaction-cards">
            {transactionsWithBalance.map((tx) => (
              <div className="transaction-card" key={tx._id}>
                <p>
                  <strong>Date:</strong>{" "}
                  {new Date(tx.createdAt).toLocaleString()}
                </p>
                <p>
                  <strong>Type:</strong>{" "}
                  <span className={tx.type === "credit" ? "credit" : "debit"}>
                    {tx.type.toUpperCase()}
                  </span>
                </p>
                <p className="amount-wrapper">
                  <strong>Amount:</strong>{" "}
                  <img src={logo} alt="coin" className="coin-icon" />
                  {tx.amount}
                </p>
                <p>
                  <strong>Description:</strong> {tx.description}
                </p>
                <p className="amount-wrapper">
                  <strong>Balance After:</strong>{" "}
                  <img src={logo} alt="coin" className="coin-icon" />
                  {tx.balanceAfter}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default UserTransactionHistory;
